(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cpp-ref-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(event.target.matches('[data-cppr-locale]'))event.target.form.requestSubmit();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpp-test-series-shop"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('cpp-test-series-shop')){
    customElements.define('cpp-test-series-shop',class extends HTMLElement{
      connectedCallback(){
        this.onClick=(event)=>{
          const button=event.target.closest('[data-cpp-board]');
          if(button&&this.contains(button)){this.select(button.dataset.cppBoard);return;}
          const link=event.target.closest('a[href]');
          if(!link)return;
          const url=new URL(link.href,location.href);
          if(url.origin!==location.origin)return;
          const board=url.pathname.includes('/products/chate-prep-plus-10th-test-series-cbse')?'cbse':url.pathname.includes('/products/chate-prep-plus-10th-test-series-maharashtra-board')?'mh':null;
          if(board){event.preventDefault();this.select(board);if(!link.closest('.cpp-board-chooser')){const panel=document.querySelector('.cpp-shop-product:not([hidden])');panel?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}}
        };
        document.addEventListener('click',this.onClick);
        this.select('mh');
        requestAnimationFrame(()=>this.select('mh'));
      }
      disconnectedCallback(){document.removeEventListener('click',this.onClick);}
      select(board){
        this.querySelectorAll('[data-cpp-board]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.cppBoard===board)));
        ['mh','cbse'].forEach(key=>{
          const suffix=this.dataset[key+'Section'];
          const panel=Array.from(document.querySelectorAll('.shopify-section')).find(node=>node.id.endsWith('__'+suffix));
          if(!panel)return;
          panel.classList.add('cpp-shop-product');panel.hidden=key!==board;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const cppLanguagePreferenceKey = 'cpp-language-preference-v1'
  const cppLanguagePromptCookie = 'cpp_language_prompt_seen'

  class CppLanguageWelcome extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return
      this.dataset.initialized = 'true'
      this.dialog = this.querySelector('dialog')
      this.form = this.querySelector('form')
      this.input = this.querySelector('[data-language-welcome-input]')
      this.closeButton = this.querySelector('[data-language-welcome-close]')
      this.options = [...this.querySelectorAll('[data-language-code]')]
      this.currentLanguage = this.dataset.currentLanguage

      if (!this.dialog || !this.form || !this.input || this.hasPreference()) return

      this.closeButton?.addEventListener('click', () => this.dismiss())
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault()
        this.dismiss()
      })
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dismiss()
      })
      this.options.forEach((option) => {
        option.addEventListener('click', () => this.selectLanguage(option))
      })

      this.dialog.hidden = false
      requestAnimationFrame(() => {
        if (!this.dialog.open) this.dialog.showModal()
        const currentOption = this.querySelector('[data-language-code][aria-current="true"]')
        currentOption?.focus({ preventScroll: true })
      })
    }

    hasPreference() {
      let storedLanguage = ''

      try {
        storedLanguage = localStorage.getItem(cppLanguagePreferenceKey) || ''
      } catch (error) {
        void error
      }

      if (storedLanguage) return true

      return document.cookie
        .split('; ')
        .some((entry) => entry.startsWith(`${cppLanguagePromptCookie}=`))
    }

    savePreference(languageCode) {
      try {
        localStorage.setItem(cppLanguagePreferenceKey, languageCode)
      } catch (error) {
        void error
      }

      document.cookie = `${cppLanguagePromptCookie}=${encodeURIComponent(languageCode)}; Max-Age=31536000; Path=/; SameSite=Lax`
    }

    dismiss() {
      this.savePreference(this.currentLanguage || 'current')
      if (this.dialog.open) this.dialog.close()
      this.dialog.hidden = true
    }

    selectLanguage(option) {
      const languageCode = option.dataset.languageCode
      if (!languageCode) return

      this.savePreference(languageCode)
      this.options.forEach((item) => {
        item.disabled = true
      })

      if (languageCode === this.currentLanguage) {
        this.dismiss()
        return
      }

      this.input.value = languageCode
      const returnToInput = this.form.elements.namedItem('return_to')
      if (returnToInput instanceof HTMLInputElement) {
        const returnUrl = new URL(
          `${window.location.pathname}${window.location.search}${window.location.hash}`,
          window.location.origin
        )
        const previewThemeId = this.dataset.previewThemeId

        if (previewThemeId) returnUrl.searchParams.set('preview_theme_id', previewThemeId)

        returnToInput.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`
      }
      this.form.submit()
    }
  }

  if (!customElements.get('cpp-language-welcome')) {
    customElements.define('cpp-language-welcome', CppLanguageWelcome)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
